export class Logger {
    constructor(name) {
        this.name = `APW::${name}`;
    }
    info(...rest) {
        // biome-ignore lint/suspicious/noConsole: <explanation>
        console.info(`${this.name}::`, ...rest);
    }
    warn(...rest) {
        // biome-ignore lint/suspicious/noConsole: <explanation>
        console.warn(`${this.name}::`, ...rest);
    }
    error(...rest) {
        // biome-ignore lint/suspicious/noConsole: <explanation>
        console.error(`${this.name}::`, ...rest);
    }
    debug(...rest) {
        // biome-ignore lint/suspicious/noConsole: <explanation>
        console.debug(`${this.name}::`, ...rest);
    }
}
